module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b44f5ffe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/navigation/Navigation.vue
// module id = 117
// module chunks = 2